module.exports = __webpack_public_path__ + "static/media/hotel_lobby.3e330784.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/backgrounds/hotel_lobby.jpg
// module id = 2392
// module chunks = 0